import { render, staticRenderFns } from "./newsletterES.vue?vue&type=template&id=70a540ca"
import script from "./newsletterES.vue?vue&type=script&lang=js"
export * from "./newsletterES.vue?vue&type=script&lang=js"
import style0 from "./newsletterES.vue?vue&type=style&index=0&id=70a540ca&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports